<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <v-container>
      <v-row justify="center" align="center" class="mb-5">
        <v-col cols="6" class="text-left">
          <validation-provider
            v-slot="{ errors, valid }"
            name="Fecha cita"
            rules="required"
          >
            <v-text-field
              v-model.trim="model.appointmentDate"
              label="Fecha cita"
              required
              autocomplete="off"
              :error-messages="errors"
              :min="minDateTime"
              disabled
              type="datetime"
              outlined
              dense
            >
              <v-icon slot="append" :color="valid ? 'success' : ''">
                {{ valid ? " mdi-check" : "" }}
              </v-icon>
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="6" md="6" sm="12">
          <validation-provider
            v-slot="{ errors }"
            name="Especialidad"
            rules="required"
          >
            <v-autocomplete
              prepend-icon="mdi mdi-cube-unfolded"
              v-model="model.especialityAppointment"
              label="Especialidad"
              no-data-text="Sin especialidades por mostrar"
              :items="specialityList"
              item-text="name"
              item-value="idSpeciality"
              :error-messages="errors"
              required
              return-object
              clearable
              dense
              @change="
                checkbutton();
                checkSpecialityWithModal();
              "
            ></v-autocomplete>
          </validation-provider>
        </v-col>
        <template
          v-if="
            model.especialityAppointment.idSpeciality == 3 ||
              model.especialityAppointment.idSpeciality == 2
          "
        >
          <v-col cols="6" md="6" sm="12">
            <validation-provider
              v-slot="{ errors }"
              name="Modalidad"
              rules="required"
            >
              <v-autocomplete
                prepend-icon="mdi mdi-developer-board"
                v-model="model.modalityAppointment"
                label="Modalidad"
                no-data-text="Sin modalidad por mostrar"
                :items="modalityList"
                item-text="name"
                item-value="idModality"
                :error-messages="errors"
                required
                clearable
                dense
                @change="
                  unfill = true;
                  fillStudyProfile();
                "
              ></v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <validation-provider
            v-slot="{ errors }"
            name="perfil  de estudio"
            rules="required"
          >
              <v-autocomplete
                prepend-icon="mdi mdi-file-alert-outline"
                v-model="model.studyProfileAppointment"
                label="Perfil de estudio"
                no-data-text="Sin perfil de estudio por mostrar"
                :items="labStudyProfileList"
                item-text="name"
                item-value="idStudyModality"
                :error-messages="errors"
                required
                return-object
                clearable
                dense
                @change="unfill = false"
              ></v-autocomplete>
            </validation-provider>
          </v-col>
        </template>
        <v-col cols="6" md="6" sm="12">
          <template>
            <v-col align="right">
              <v-btn
                color="primary"
                outlined
                @click="addAppointment()"
                :disabled="unfill || invalid"
                >Agregar cita <v-icon right>mdi-plus</v-icon></v-btn
              >
            </v-col>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                depressed
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="laststep()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                paso anterior
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </validation-observer>
</template>
<script>
import AppointmentSometryModal from "@/app/components/reception/AppointmentSometryModal.vue";
import AppointmentsTablexUser from "@/app/components/reception/AppointmentsTablexUser.vue";
import {
  ModaltyRequest,
  SpecialityRequest,
  StudyModalityRequest,
} from "@/core/request";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    AppointmentSometryModal,
    AppointmentsTablexUser,
  },
  data() {
    return {
      model: {
        // appointmentDate: new Date(),
        especialityAppointment: {},
        modalityAppointment: "",
        studyProfileAppointment: {},
      },
      specialityList: [],
      modalityListRequest: [],
      studyProfileList: [],
      minDateTime: null,
      modalityList: [],
      labModalityList: [],
      imgModalityList: [],
      labStudyProfileList: [],
      imgStudyProfileList: [],
      appointmentsList: [],
      unfill: true,
      unsave: true,
      dialogAppointment: false,
      flagModal: false,
      flagSave: false,
      appointmentData: {},
    };
  },
  created() {
    this.listAppointment();
    this.minDateTime = this.$utilFront.getCurrentDateTime();
    this.model.appointmentDate = this.minDateTime;
  },
  methods: {
    checkSpecialityWithModal() {
      if (
        this.model.especialityAppointment.idSpeciality == 2 ||
        this.model.especialityAppointment.idSpeciality == 3
      ) {
        this.fillModality();
      } else {
        return;
      }
    },
    checkbutton() {
      if (
        this.model.especialityAppointment.idSpeciality == 2 ||
        this.model.especialityAppointment.idSpeciality == 3
      ) {
        this.unfill = true;
      } else {
        this.unfill = false;
      }
    },
    listAppointment() {
      ModaltyRequest.allModality().then((res) => {
        let modality = res.data.data;
        this.modalityListRequest = modality;
      });
      SpecialityRequest.allSpeciality().then((res) => {
        let speciality = res.data.data;
        let filter = speciality.filter(
          (specialty) => specialty.idSpeciality != 1
        );
        this.specialityList = filter;
      });
      StudyModalityRequest.allStudyModality().then((res) => {
        let studyprofile = res.data.data;
        this.studyProfileList = studyprofile;
      });
    },
    validateDoubleAppointment() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].studyProfile.idStudyProfile ==
          this.appointmentData.studyProfile.idStudyProfile
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
        this.$emit("updateList", this.appointmentsList);
      }
    },
    validateAppointmentWithoutModality() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].speciality.idSpeciality ==
          this.appointmentData.speciality.idSpeciality
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
        this.$emit("updateList", this.appointmentsList);
      }
    },
    clearAppointments() {
      this.unfill = true;
      this.model.especialityAppointment = {};
      this.model.modalityAppointment = "";
      this.model.studyProfileAppointment = {};
      //   this.appointmentData = {};
    },
    fillModality() {
      let labModality = [];
      let imgModality = [];
      if (this.model.especialityAppointment.idSpeciality == 3) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.model.especialityAppointment.idSpeciality
          ) {
            labModality = this.modalityListRequest[h];
            this.labModalityList.push(labModality);
          }
          this.modalityList = this.labModalityList;
        }
      } else if (this.model.especialityAppointment.idSpeciality == 2) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.model.especialityAppointment.idSpeciality
          ) {
            imgModality = this.modalityListRequest[h];
            this.imgModalityList.push(imgModality);
          }
        }
        this.modalityList = this.imgModalityList;
      }
      this.fillStudyProfile();
    },

    addAppointment() {
      if (this.appointmentsList.length > 0) {
        this.flagModal = true;
      } else {
        this.flagModal = false;
      }
      if (
        this.model.especialityAppointment.idSpeciality == 2 ||
        this.model.especialityAppointment.idSpeciality == 3
      ) {
        let appointment = {
          //   date: new Date(),
          speciality: {
            idSpeciality: this.model.especialityAppointment.idSpeciality,
            name: this.model.especialityAppointment.name,
          },
          modality: {
            idModality: this.model.modalityAppointment,
            name: this.model.studyProfileAppointment.modality.name,
          },
          studyProfile: {
            idStudyProfile: this.model.studyProfileAppointment.idStudyModality,
            name: this.model.studyProfileAppointment.name,
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.$emit("updateList", this.appointmentsList);
          this.clearAppointments();
        } else if (this.appointmentsList.length > 0) {
          this.validateDoubleAppointment();
          this.clearAppointments();
        }
      } else {
        let appointment = {
          //   date: new Date(),
          speciality: {
            idSpeciality: this.model.especialityAppointment.idSpeciality,
            name: this.model.especialityAppointment.name,
          },
          modality: {
            idModality: "",
            name: "----",
          },
          studyProfile: {
            idStudyProfile: "",
            name: "----",
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.clearAppointments();
          this.$emit("updateList", this.appointmentsList);
        } else if (this.appointmentsList.length > 0) {
          this.validateAppointmentWithoutModality();
          this.clearAppointments();
        }
      }
    },
    fillStudyProfile() {
      let labStudyProfile = [];
      this.labStudyProfileList = [];
      for (let h in this.studyProfileList) {
        if (
          this.studyProfileList[h].modality.idModality ==
          this.model.modalityAppointment
        ) {
          labStudyProfile = this.studyProfileList[h];
          this.labStudyProfileList.push(labStudyProfile);
        }
      }
    },
    laststep() {
      this.$emit("laststep", 4);
    },
  },
};
</script>
